import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

// ✅ Read number from environment variable
const phoneNumber = process.env.NEXT_PUBLIC_WHATSAPPNUMBER;

export default function WhatsAppFloatingButton() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const preFilledMessage = encodeURIComponent(
    "Hi SRK Trends, I have an enquiry about your collection."
  );

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${preFilledMessage}`;

  return (
    <a
      href={whatsappURL}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed z-50 bottom-6 right-4 md:right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 ${
        isMobile ? "block" : "hidden"
      }`}
    >
      <FaWhatsapp size={24} />
    </a>
  );
}